import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

console.log('🎬 main.tsx: Starting WISC-V application...');
console.log('📦 Environment check:', {
  mode: import.meta.env.MODE,
  hasRoot: !!document.getElementById('root'),
  viteKeys: Object.keys(import.meta.env).filter(k => k.startsWith('VITE_'))
});

try {
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    console.error('❌ main.tsx: Root element not found!');
    throw new Error('Root element #root not found in DOM');
  }

  console.log('✅ main.tsx: Root element found, creating React root...');

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  console.log('✅ main.tsx: React app rendered successfully!');
} catch (error) {
  console.error('❌ main.tsx: Fatal error:', error);

  // Display error on page for debugging
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: monospace; background: #fee; color: #c00;">
      <h1>❌ Application Failed to Load</h1>
      <pre>${error instanceof Error ? error.stack : String(error)}</pre>
      <p>Check browser console (F12) for details</p>
    </div>
  `;
}